/// <reference types="google.maps" />
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */

import { FormGroup, AbstractControl } from '@angular/forms';

export function setAddressObject(
  address_components: google.maps.GeocoderAddressComponent[],
  formGroup: FormGroup,
  controlNames: { city: string; state: string; addressLine1: string; addressLine2: string; postalCode: string; }
) {
  let address1 = '';
  let address2 = '';
  let postcode = '';

  address_components.forEach((component) => {
    const componentType = component.types[0];

    switch (componentType) {
      case 'street_number': {
        address1 = `${component.long_name} ${address1}`;
        break;
      }

      case 'route': {
        address1 += component.short_name;
        break;
      }

      case 'subpremise': {
        address2 = component.long_name;
        break;
      }

      case 'postal_code': {
        postcode = `${component.long_name}${postcode}`;
        break;
      }

      case 'locality': {
        formGroup.get(controlNames.city).setValue(component.long_name);
        break;
      }

      case 'administrative_area_level_1': {
        formGroup.get(controlNames.state).setValue(component.short_name);
        break;
      }

      default: '';
    }
  });

  formGroup.get(controlNames.addressLine1).setValue(address1);
  formGroup.get(controlNames.addressLine2).setValue(address2);
  formGroup.get(controlNames.postalCode).setValue(postcode);
}

interface ServerValidationError {
  address_line1?: { streetNumber: boolean; };
  address_line2?: { subpremise: boolean; };
  city?: { locality: boolean; };
  state?: { administrativeAreaLevel1: boolean; };
  postal_code?: { postalCode: boolean; };
}

export function setServerValidationErrors(
  form: FormGroup,
  errors: any,
  setSaveFailure: (value: boolean) => void,
  incrementServerValidationFailedCount: () => void
): void {
  const saveFailure = true;

  if (typeof setSaveFailure === 'function') {
    setSaveFailure(saveFailure);
  }

  if (typeof incrementServerValidationFailedCount === 'function') {
    incrementServerValidationFailedCount();
  }

  if (errors) {
    const formError: ServerValidationError = {};
    const hasAddressLine1Error = Object.hasOwnProperty.call(errors, 'street_number')
    || Object.hasOwnProperty.call(errors, 'route');
    const hasAddressLine2Error = Object.hasOwnProperty.call(errors, 'subpremise');
    const noAddressLineError = !hasAddressLine1Error && !hasAddressLine2Error;

    if (hasAddressLine1Error) {
      formError.address_line1 = { streetNumber: true };
    }

    if (
      hasAddressLine2Error &&
      (!hasAddressLine1Error || !errors['subpremise'].some((err: string) => err.includes('unconfirmed')))
    ) {
      formError.address_line2 = { subpremise: true };
    }

    if (
      Object.hasOwnProperty.call(errors, 'locality') &&
      (!errors['locality'].some((err: string) => err.includes('unconfirmed')) || noAddressLineError)
    ) {
      formError.city = { locality: true };
    }

    if (
      Object.hasOwnProperty.call(errors, 'administrative_area_level_1') &&
      (!errors['administrative_area_level_1'].some((err: string) => err.includes('unconfirmed')) || noAddressLineError)
    ) {
      formError.state = { administrativeAreaLevel1: true };
    }

    if (
      Object.hasOwnProperty.call(errors, 'postal_code') &&
      (!errors['postal_code'].some((err: string) => err.includes('unconfirmed')) || noAddressLineError)
    ) {
      formError.postal_code = { postalCode: true };
    }

    // Apply form errors
    Object.keys(formError).forEach((key) => {
      const control: AbstractControl = form.get(key);
      if (control && formError[key]) {
        control.setErrors(formError[key]);
      }
    });

    form.markAllAsTouched();
  }
}
